/* eslint-disable @typescript-eslint/no-explicit-any */
import { RouteComponentProps } from 'react-router-dom';
import { parse } from '@tock/query-string';
import _ from 'lodash';

import { IWithContextProps, withContext } from '@tock/coretypes';
import BaseComponent from '@tock/shared/components/BaseComponent';
import ConsumerOverlay from 'components/ConsumerOverlay';
import OAuth, { Network, OAuthProfile, loginWith } from 'components/OAuth';
import connect, { DefaultConnectProps } from '@tock/shared/utils/connect';

interface Props {
  onSuccess(network: Network, accessToken: any, profile: OAuthProfile): void;
  onFailure(err: { error: string | object }): Promise<any> | void;
}

class OAuthCheckRoute extends BaseComponent<
  Props & DefaultConnectProps & RouteComponentProps & IWithContextProps
> {
  applyAnalyticsReferrerFix = !!this.props.features.SOCIAL_LOGIN_ANALYTICS_REFERRER_FIX;

  getAccessToken() {
    const query = parse(this.props.location.search);
    loginWith(
      query.network as Network,
      query.from,
      query.continue,
      this.applyAnalyticsReferrerFix,
      'none'
    );
  }

  render() {
    return (
      <ConsumerOverlay isLoading={_.includes(this.props.location.pathname, '/oauth-check')}>
        <OAuth
          onInitialized={this.getAccessToken}
          onLoginSuccess={this.props.onSuccess}
          onLoginFailure={this.props.onFailure}
          applyAnalyticsReferrerFix={this.applyAnalyticsReferrerFix}
        />
      </ConsumerOverlay>
    );
  }
}

export default connect<RouteComponentProps & Props>(withContext(OAuthCheckRoute), ['patron']);
